export const environment = {
  production: false,
  graphqlEndpoint: 'https://r47s2f32arhobmy55mfoim5kie.appsync-api.eu-central-1.amazonaws.com/graphql',
  region: 'eu-central-1',
  helpApiUrl: 'https://bri1qgh7wc.execute-api.eu-central-1.amazonaws.com',
  amplifyConfiguration: {
    userPoolId: 'eu-central-1_0VRAVuGaz',
    userPoolClientId: '3di1aiunnc6j4b9421n04nno6u',
    oauth: {
      domain: 'insolution-manager-auth-domain-dev.auth.eu-central-1.amazoncognito.com',
      scopes: ['email', 'openid', 'profile'],
      redirectSignIn: ['https://d2vqv84tkz655o.cloudfront.net/'],
      redirectSignOut: ['https://d2vqv84tkz655o.cloudfront.net/'],
      responseType: 'code',
    },
  },
  rumConfiguration: {
    appMonitorId: 'b65160db-288c-4902-9ea4-5fb40fafdebc',
    identityPoolId: 'eu-central-1:4a5a134f-47a8-4b1d-bacc-22a0da07286e',
    region: 'eu-central-1',
    appVersion: 'web',
    sampleRate: 1,
  },
};
